<div class="insights-container">
  <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
      <div class="col-md-6 ps-0 pe-0">
        <app-temperature-comfort-zone-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes" [companyData]="companyData" [isMetric]="isMetric"></app-temperature-comfort-zone-chart>
      </div>
      <div class="col-md-6 ps-0 pe-0">
        <!-- <app-time-spent-extreme-temp-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes"></app-time-spent-extreme-temp-chart> -->
      </div>
  </div>

  <hr class="ms-2 me-2 mt-1 mb-1 ps-0 pe-0">

  <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
    <div class="col-md-6 ps-0 pe-0">
      <!-- <app-time-spent-extreme-temp-low-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes"></app-time-spent-extreme-temp-low-chart> -->
    </div>
    <div class="col-md-6 ps-0 pe-0">
      <!-- <app-time-spent-extreme-temp-high-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes"></app-time-spent-extreme-temp-high-chart> -->
    </div>
  </div>
</div>